export function toLocalStringWithTimeZone(date: Date | undefined, options: { timeZone?: string } = {}): string {
  if (!date) {
    return '';
  }
  return date.toLocaleString(undefined, { timeZoneName: 'short', ...options });
}
